import React from "react";

interface LomavisH3Props {
    /** The text to display inside the H3 heading */
    title: string;
    /** Optional additional CSS class names */
    className?: string;
}

/**
* Atoms: LomavisH3
*/
export const LomavisH3: React.FC<LomavisH3Props> = ({ title, className = "" }) => {
    return <h3 className={`fs-3 ${className}`.trim()}>{title}</h3>;
};